module.exports = __webpack_public_path__ + "img/title3.205fccaf.png";